import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { getWebsitesData } from '../table/table.slice';

export interface AppState {
  imgPreviewUrl: string | null;
  infoModalOpened: boolean;
  requestError: string | null;
}

const initialState: AppState = {
  imgPreviewUrl: null,
  infoModalOpened: false,
  requestError: null,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    requestError(state, action: PayloadAction<string | null>) {
      state.requestError = action.payload;
    },
    toggleImgPreviewModal(state, action: PayloadAction<string | null>) {
      state.imgPreviewUrl = action.payload;
    },
    toggleInfoModalOpened(state, action: PayloadAction<boolean>) {
      state.infoModalOpened = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getWebsitesData.rejected, (state, action) => {
      const { payload, error } = action;
      state.requestError = payload?.message ?? error.message ?? null;
    });
  },
});

export const { requestError, toggleImgPreviewModal, toggleInfoModalOpened } =
  appSlice.actions;

export const appReducer = appSlice.reducer;
